import { render, staticRenderFns } from "./dynamic-drawer.vue?vue&type=template&id=4ae3d07d&scoped=true&"
import script from "./dynamic-drawer.vue?vue&type=script&lang=js&"
export * from "./dynamic-drawer.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-drawer.vue?vue&type=style&index=0&id=4ae3d07d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae3d07d",
  null
  
)

export default component.exports